.band {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

/* 700×520 behind the text column, 60 px left of and 40 px above it. A surface can move it with the variables. */
.scrim {
  position: absolute;
  left: var(--journey-scrim-x, -60px);
  top: var(--journey-scrim-y, -40px);
  width: 700px;
  height: 520px;
  max-width: none;
  z-index: -1;
  pointer-events: none;
}

.dark {
  background: radial-gradient(ellipse at 42% 45%, rgba(15, 43, 60, 0.6) 0%, rgba(15, 43, 60, 0.3) 40%, transparent 62%);
}

.light {
  background: radial-gradient(ellipse at 42% 45%, rgba(251, 248, 242, 0.8) 0%, rgba(251, 248, 242, 0.4) 40%, transparent 62%);
}

/* Like fb/web: no wide shadow line on small screens. */
@media (max-width: 999px) {
  .shadow {
    display: none;
  }
}
